import React from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  return (
    <header
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "50px 0",
        background: "transparent",
        position: "relative",
        zIndex: 2000,
        width: "100%",
      }}
    >
      <NavLink
        to="https://hadenka.com/"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textDecoration: "none",
        }}
      >
        <img
          src="/images/home/corgo.png"
          alt="Corgo Logo"
          style={{
            width: "380px", // Large size as requested
            maxWidth: "85vw", // Responsive scaling
            height: "auto",
            display: "block",
            transition: "transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
          }}
          onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.04)")}
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />
      </NavLink>
    </header>
  );
};

export default Header;
